module.exports = __webpack_public_path__ + "static/media/LoginPage-BG.413f1f53.jpg";